module.exports = __webpack_public_path__ + "static/media/VRT-BNB.9a36b130.svg";